import { MulticastDelegate, MulticastDelegate1, Delegate } from "flavr-common";
import { FrameStats } from "./FrameStats";
class AnimationFrame extends MulticastDelegate1 {
    constructor() {
        super(...arguments);
        this.onInputUpdate$ = new MulticastDelegate1();
        this.onMovementUpdate$ = new MulticastDelegate();
        this.onPreRender$ = new MulticastDelegate();
        this.onRender$ = new MulticastDelegate();
        this.onLateUpdate$ = new MulticastDelegate();
        // For stats only
        this.frameStats = new FrameStats();
        this.onUpdateStatsBeginDelegate = new Delegate();
        this.onUpdateStatsEndDelegate = new Delegate();
    }
}
/**
 * Will be fired for each frame in our game-loop.
 */
export const animationFrame$ = new AnimationFrame();
